/*
* @Author: jack
* @Date:   2020-01-05 16:45:08
* @Last Modified by:   jack
* @Last Modified time: 2020-09-21 14:43:58
*/
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function upload(file) {
  let data = new FormData()
  data.append('file', file, file.name)
  return request({
    headers: { 
      'Content-Type': 'multipart/form-data'
    },
    url: 'https://b.anhuiyun.com/prod/api/v1/ugc/imageUpload',
    method: 'post',
    data
  })
}

export function add(data) {
  return request({
    url: 'https://b.anhuiyun.com/prod/api/v1/ugc/data',
    method: 'post',
    data
  })
}
